import { HandlerAbstract } from './handlerAbstract'

export class ReplaceHandler extends HandlerAbstract {

}
